var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerson24Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.772 24.557",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".person-24px_svg__a{fill:inherit}.person-24px_svg__a,.person-24px_svg__c,.person-24px_svg__d{stroke:inherit}.person-24px_svg__d{fill:none}.person-24px_svg__c{fill:transparent}.person-24px_svg__c,.person-24px_svg__d{stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-svg-primary": "all",
    className: "person-24px_svg__a",
    d: "M10.933 10.933a3.467 3.467 0 10-3.466-3.466 3.466 3.466 0 003.466 3.466zm0 1.733C8.619 12.666 4 13.828 4 16.133v1.733h13.866v-1.733c0-2.305-4.619-3.467-6.933-3.467z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-svg-primary": "stroke",
    className: "person-24px_svg__c",
    d: "M24.272 16.728l-7.1 7.1-2.084.234.24-2.084 7.094-7.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-svg-primary": "stroke",
    className: "person-24px_svg__d",
    d: "M21.207 16.618l1.388 1.388"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-24px.67f8959173e99f681be461a8059249b7.svg";